<template>
  <div class="god_page_container">
    <h2>Cupones</h2>
    <div id="selector_container">
      <input
        type="email"
        class="input_200"
        v-model="coupon"
        placeholder="Buscar cupón"
      />

      <label class="input_200" style="display: flex; align-items: center; gap: 5px;">
        <input type="checkbox" name="aceptar" v-model="showExpired">
        Mostrar caducados
      </label>

      <button @click="getCoupons()" class="input_200 main_button">Buscar</button>

      <button @click="addCoupon()" class="input_200 main_button">
        Añadir cupón
        <img class="action_icon_white" src="@/assets/images/ic_add.png" />
      </button>

    </div>
    
    <div class="table-container">
      <table>
        <thead>
          <tr>
              <th class="small">Codigo</th>
              <th class="small">Descuento</th>
              <th class="small">Usos</th>
              <th class="small">Caducidad</th>
              <th class="small">Plataforma</th>
              <th class="small">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr 
            v-for="(item, index) in coupons"
            :key="item.codigo"
            :class="index % 2 === 0 ? 'bg-gray-100' : 'bg-white'"
          >
            <td><span v-if="!item.activo">🚫 </span>{{ item.codigo }}<span v-if="!item.activo"> 🚫</span></td>
            <td>{{ item.valor_descuento }} {{ item.tipo_descuento == "euros" ? "€" : "%" }}</td>
            <td>{{ item.usos }} ({{ item.usos_maximo == "0" ? "sin límite" : (item.usos_maximo + " max") }})</td>
            <td>{{ item.fecha_caducidad }}</td>
            <td>{{ obtenerPlafaforma(item.platform) }}</td>
            <td>
              <img class="action_icon" src="@/assets/images/ic_action_edit.png" @click="onEditClicked(item)"/>
              <img class="action_icon" src="@/assets/images/ic_action_delete.png" @click="onDeleteClicked(item)"/>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <CouponDetailsPopup
      :show-coupon-popup="showCouponPopup"
      :coupon="selectedCoupon"
      @couponSaved="onCouponSaved"
      @couponPopupCancelled="couponPopupCancelled"
      @errorHappened="errorHappened"
      />

    <ErrorPopup :errorMessage="error" />
    <TwoButtonPopup
      :title="twoButtonTitle"
      :message="twoButtonMessage"
      :acceptButton="twoButtonAcceptButton"
      @acceptCallback="() => twoButtonConfirmed()"
      :cancelButton="twoButtonCancelButton"
      @cancelCallback="() => twoButtonCancelled()"
      />

  </div>

</template>

<script setup>
  import { ref, nextTick, watch } from 'vue'
  import { useLoadingStore } from "@/stores/loadingStore";
  import { refreshToken } from "@/services/authService";
  import { useRouter, useRoute } from 'vue-router';
  import ErrorPopup from "@/components/common/ErrorPopup.vue";
  import TwoButtonPopup from "@/components/common/TwoButtonPopup.vue";
  import CouponDetailsPopup from "@/components/coupons/CouponDetailsPopup.vue";

  const showCouponPopup = ref(false);
  const selectedCoupon = ref(null);

  const error = ref(null);
  const coupons = ref([]);
  const loadingStore = useLoadingStore();

  const router = useRouter();
  const route = useRoute();

  const showExpired = ref(route.query.showExpired === 'true');
  const coupon = ref(route.query.coupon || '');

  watch([showExpired, coupon], () => {
    router.replace({
      query: {
        ...route.query,
        showExpired: showExpired.value,
        coupon: coupon.value
      }
    });
  });

  const twoButtonTitle = ref("");
  const twoButtonMessage = ref("");
  const twoButtonAcceptButton = ref("");
  const twoButtonCancelButton = ref("");
  let twoButtonConfirmed = null;
  let twoButtonCancelled = null;

  function obtenerPlafaforma(platform) {
    switch (platform) {
      case 'app':
        return 'App';
      case 'web':
        return 'Web';
      default:
        return 'Todas';
    }
  }

  const getCoupons = async () => {
    loadingStore.setLoading(true);
    error.value = null;

    try {
      let response = await callAPIToGetCoupons();

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await callAPIToGetCoupons();
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        showError("Se ha producido un error obteniendo los cupones.");
        return;
      }

      const data = await response.json();

      if (data.errors) {
        showError(data.message);
        coupons.value = [];
      } else {
        coupons.value = data.coupons;
      }
    } catch (exception) {
      showError(exception.message);
    } finally {
      loadingStore.setLoading(false);
    }
  }

  async function callAPIToGetCoupons() {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/coupons/get?user_id="+localStorage.getItem('user_id')
      +"&show_expired="+(showExpired.value ? "1" : "0")
      + (coupon.value != '' ? "&coupon="+coupon.value : ""),
       {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "vgod": process.env.VUE_APP_API_VGOD,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token')
        },
      });
  }

  const onEditClicked = async (item) => {
    if (!item.codigo.includes(" (Amigo)")) {
      selectedCoupon.value = item;
      showCouponPopup.value = true;
    } else {
      showError("No se pueden editar los cupones de amigo.");
    }
  };

  const onDeleteClicked = async (item) => {
    twoButtonTitle.value = item.activo ? "Desactivar cupón" : "Activar cupón";
    twoButtonMessage.value = item.activo ? "¿Estás seguro de que deseas desactivar este cupón?" : "¿Estás seguro de que deseas activar este cupón?";
    twoButtonAcceptButton.value = "Aceptar";
    twoButtonCancelButton.value = "Cancelar";
    twoButtonConfirmed = () => {
      twoButtonTitle.value = "";
      twoButtonMessage.value = "";
      twoButtonAcceptButton.value = "";
      twoButtonCancelButton.value = "";
      changeCouponVisibilityConfirmed(item);
    };
    twoButtonCancelled = () => {
      twoButtonTitle.value = "";
      twoButtonMessage.value = "";
      twoButtonAcceptButton.value = "";
      twoButtonCancelButton.value = "";
    }
  };

  const changeCouponVisibilityConfirmed = async (item) => {
    loadingStore.setLoading(true);
    error.value = null;

    try {
      let response = await changeCouponVisibilityInAPI(item);

      if (response.status === 401) {
        const refreshed = await refreshToken();
        if (refreshed) {
          response = await changeCouponVisibilityInAPI();
        } else {
          loadingStore.setLoading(false);
          localStorage.removeItem('user_id');
          localStorage.removeItem('token');
          router.push('/');
          return;
        }
      }

      if (!response.ok) {
        showError("Se ha producido un error cambiando el estado del cupón.");
        return;
      }

      const data = await response.json();

      if (data.errors) {
        showError(data.message);
      } else {
        error.value = null;
      }
    } catch (exception) {
      showError(exception.message);
    } finally {
      getCoupons();
    }
  };

  const changeCouponVisibilityInAPI = async (item) => {
    return await fetch(process.env.VUE_APP_API_URL+"api/god/coupons/edit_visibility", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "vgod": process.env.VUE_APP_API_VGOD,
          "cp-token": process.env.VUE_APP_API_CP_TOKEN,
          "Authorization": "Bearer " + localStorage.getItem('token')
        },
        body: JSON.stringify({
          "user_id": localStorage.getItem('user_id'),
          "coupon": item.codigo.replace(" (Amigo)", ""),
          "visibility": item.activo ? 0 : 1 
        }),
      });
  };

  const showError = async (message) => {
    error.value = null;
    await nextTick(); // Espera a que Vue reaccione al cambio
    error.value = message;
  };

  async function addCoupon() {
    selectedCoupon.value = null;
    showCouponPopup.value = true;
  }

  const onCouponSaved = () => {
    showCouponPopup.value = false;
    getCoupons();
  };

  getCoupons();

  const couponPopupCancelled = () => {
    showCouponPopup.value = false;
  }

  const errorHappened = (message) => {
    showError(message);
  }
</script>

<style scoped>

#selector_container {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  padding-top: 1rem;
  justify-content: space-between;
}

.input_200 {
  box-sizing: border-box;
  min-width: 200px;
  flex: 1 1 200px;
  padding: 8px;
  width: 100%;
  line-height: 1.2;
  height: 50px;
  max-height: 50px;
}

.radio-group {
  display: flex;
  flex-direction: column;
  min-width: 200px;
  flex: 1 1 200px;
}

.button {
  margin-left: auto;
  display: flex;
  align-items: center;
  cursor: pointer;
  flex: 1 1 200px;
}

.table-container {
  overflow-x: auto;
  width: 100%;
}

table {
  width: 100%;
  border-collapse: collapse;
  border-radius: 10px;
  overflow: hidden;
  margin-top: 30px;
  min-width: 800px; /* evita que se aplaste */
}

th {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
  background-color: var(--gray);
  color: white;
  border: 0px;
}

tfoot {
  background-color: var(--gray);
  color: white;
  border: 0px;
}
.big {
  width: 20%;
}

.small {
  width: 10%;
}

tr{
  cursor: pointer;
}

td {
  text-align: center;
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 5px;
  padding-right: 5px;
}

.bg-gray-100 {
  background-color: var(--almost-white);
}

.bg-white {
  background-color: white;
}

.action_icon {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin: 0px 5px;
}

.action_icon_white {
  width: 20px;
  height: 20px;
  cursor: pointer;
  margin-left: 10px;
  filter: brightness(0) invert(1);
}

@media (max-width: 768px) {
  #selector_container > * {
    flex: none !important;
  }

  .input_200, .radio-group {
    width: 100%;
  }

  table {
    width: 100%;
    min-width: 0px;
  }

}

</style>
